import { css } from "@emotion/css";
import { ChangeEvent, RefObject } from "react";
import { useTranslation } from "react-i18next";

export const SUCCESSFACTORS_SAP_CERTIFICATE_FILE_ACCEPT =
  ".pem,.crt,.cer,.txt,text/plain,application/x-pem-file,application/octet-stream";

export type ClientParsedOutbound = {
  x509_certificate: string;
  saml_private_key: string;
  company_id: string;
  needsManualCompanyId: boolean;
};

const hiddenFileInput = css({
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
});

type Props = {
  inputRef: RefObject<HTMLInputElement | null>;
  inputId: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export function SuccessFactorsSapCertificateFileInput({
  inputRef,
  inputId,
  onChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <input
      id={inputId}
      ref={inputRef}
      type="file"
      accept={SUCCESSFACTORS_SAP_CERTIFICATE_FILE_ACCEPT}
      data-testid="successfactors-sap-certificate-upload"
      className={hiddenFileInput}
      aria-label={t("Upload SAP OAuth certificate file")}
      onChange={onChange}
    />
  );
}
